import React, { useRef, useState } from "react"
import { toAbsoluteUrl } from "@common-metronic/helpers"
import MyLoadingOverlay from "../../../../../common/components/MyLoadingOverlay"
import { IGetViviersResponseItemModel } from "./core/_models"
import { useViviersListingContext } from "./ViviersListing"
import { useViviersListingListContext } from "./_ViviersListingList"
import { getSelectedItemPlusPreviousAndNextItem } from "./core/_helpers"
import { Link } from "react-router-dom"
import MyTooltip from "@common-utils/MyTooltip"
import { useAuth } from "../../../../AppContext"

const ListItem = ({ item, handleClickItemForPreview, isItemSelected, isItemLoading }: IListItemPropsModel) => {
     const { currentUser } = useAuth()
     const globalContext = useViviersListingContext()
     const listContext = useViviersListingListContext()
     const [isAvatarLoading, setIsAvatarLoading] = useState<boolean>(true)
     const checkboxInputRef = useRef<any>(null)

     const isItemBeingUpdated = !!globalContext.itemsBeingUpdated.find(item_ => item_.vivier.id === item.vivier.id)

     function handleOnCheckItem() {
          const isItemChecked = globalContext.isBulkSelectionEnabled.checkedElementsInPage.find((item_: IGetViviersResponseItemModel) => item_.vivier.id === item.vivier.id)
          if (!isItemChecked) {
               globalContext.setIsBulkSelectionEnabled(prev => ({
                    ...prev,
                    checkedElementsInPage: [...prev.checkedElementsInPage, item],
                    areAllElementsInAllPagesChecked: false,
               }))
          } else {
               globalContext.setIsBulkSelectionEnabled(prev => ({
                    ...prev,
                    checkedElementsInPage: prev.checkedElementsInPage.filter((item_: IGetViviersResponseItemModel) => item_.vivier.id !== item.vivier.id),
                    areAllElementsInAllPagesChecked: false,
               }))
          }
     }

     return (
          <MyLoadingOverlay isActive={isItemLoading || isItemBeingUpdated}>
               <>
                    <div
                         className={`${isItemSelected ? "border-start border-2 border-primary" : ""}`}
                         onClick={e => handleClickItemForPreview(e)}
                         ref={isItemSelected ? listContext.selectedItemRef : null}
                    >
                         <div className={`p-4 ${isItemSelected ? "mb-4 bg-light" : "cursor-pointer"}`}>
                              {/* checkbox, Avatar, nom & métier*/}
                              <div className={"d-flex justify-content-between"}>
                                   <div className={"d-flex align-items-center"}>
                                        {/* checkbox */}
                                        {globalContext.isBulkSelectionEnabled.enabled && (
                                             <div
                                                  className={
                                                       "form-check form-check-custom form-check-solid form-check-sm pe-6 ps-2 pt-4 pb-4 not-concerned-by-preview cursor-pointer"
                                                  }
                                             >
                                                  <input
                                                       type="checkbox"
                                                       className={"form-check-input cursor-pointer border border-secondary not-concerned-by-preview"}
                                                       style={{ height: "2rem", width: "2rem" }}
                                                       checked={globalContext.isBulkSelectionEnabled.checkedElementsInPage.find(
                                                            (item_: IGetViviersResponseItemModel) => item.vivier.id === item_.vivier.id
                                                       )}
                                                       onChange={() => handleOnCheckItem()}
                                                       ref={checkboxInputRef}
                                                  />
                                             </div>
                                        )}

                                        {/* Avatar */}
                                        <div className={"d-flex flex-column"}>
                                             <MyLoadingOverlay isActive={isAvatarLoading} styles={{ height: "50px", width: "50px", borderRadius: "50%" }} size={"sm"}>
                                                  <img
                                                       src={toAbsoluteUrl("/media/logos/cts/logo-cts.png")}
                                                       onLoad={() => setIsAvatarLoading(false)}
                                                       style={{ height: "50px", width: "50px", borderRadius: "50%" }}
                                                       alt="Avatar"
                                                  />
                                             </MyLoadingOverlay>
                                        </div>
                                        {/* Intitulé & Description*/}
                                        <div className={"ms-4"}>
                                             <div className={"mb-1"}>
                                                  <span className={"fs-5 fw-bold me-2 d-flex align-items-center"}>{item.vivier.intitule}</span>
                                             </div>
                                             <div>{item.vivier.description}</div>
                                        </div>
                                   </div>
                                   {item.vivier.status === "STATUT_ARCHIVED" && (
                                        <div className={"ms-auto d-flex align-items-center"}>
                                             <span className={"badge badge-dark"}>Archivé</span>
                                        </div>
                                   )}
                              </div>
                         </div>

                         {isItemSelected && (
                              <>
                                   <div className={"d-flex align-items-center px-4 pb-4"}>
                                        <div className={"col-10"}>
                                             {/*Date publication*/}
                                             <div className={`d-flex align-items-center mb-2`}>
                                                  <span className="fas fa-calendar fs-5 w-25px" />
                                                  Publiée le {item.vivier.date?.format("dddd D MMMM YYYY")}
                                             </div>
                                             {/*Responsable*/}
                                             <div className={`d-flex align-items-center mb-2`}>
                                                  <span className="fas fa-user fs-5 w-25px" />
                                                  {item.vivier.personnel?.prenomNom}
                                             </div>
                                        </div>
                                        {currentUser?.teamRecrutement?.find(item__ => item__.id === item.vivier.personnel?.id) && (
                                             <>
                                                  {item.vivier.status !== "STATUT_ARCHIVED" && (
                                                       <div className="col text-end">
                                                            <MyTooltip title={"Archiver"}>
                                                                 <button
                                                                      type={"button"}
                                                                      className={`btn btn-outline btn-outline-dark btn-sm btn-icon rounded-circle mb-2`}
                                                                      onClick={() => globalContext.handleArchive([item])}
                                                                 >
                                                                      <i className="fas fa-archive fs-4" />
                                                                 </button>
                                                            </MyTooltip>
                                                       </div>
                                                  )}
                                                  {item.vivier.status === "STATUT_ARCHIVED" && (
                                                       <div className="col text-end">
                                                            <MyTooltip title={"Restaurer"}>
                                                                 <button
                                                                      type={"button"}
                                                                      className={`btn btn-outline btn-outline-success btn-sm btn-icon rounded-circle mb-2`}
                                                                      onClick={() => globalContext.handleRestore([item])}
                                                                 >
                                                                      <i className="fas fa-globe fs-4" />
                                                                 </button>
                                                            </MyTooltip>
                                                       </div>
                                                  )}
                                             </>
                                        )}
                                   </div>
                                   <div className={"separator border-primary"} />

                                   <div className={"d-flex justify-content-center p-4"}>
                                        {item.totalCandidats > 0 ? (
                                             <Link
                                                  to={"/recrutement/candidats/search/results?vivier_id=" + item.vivier.id + "&vivier_name=" + item.vivier.intitule}
                                                  // state={{ vivier_ids: [item.vivier.id] }}
                                                  className={"btn btn-sm btn-light-dark me-4 px-2 py-1 fs-6"}
                                             >
                                                  {item.totalCandidats} {item.totalCandidats > 1 ? "candidats" : "candidat"}
                                             </Link>
                                        ) : (
                                             <span className={"text-muted"}>Aucun candidat</span>
                                        )}
                                   </div>
                              </>
                         )}
                    </div>
               </>
          </MyLoadingOverlay>
     )
}

const ViviersListingListItem = ({ item, index }: { item: IGetViviersResponseItemModel; index: number }) => {
     const context = useViviersListingContext()

     const isItemSelected: boolean = context.itemInPreview !== null && context.itemInPreview.selectedItem.vivier.id === item.vivier.id
     const isItemLoading: boolean = context.itemInPreview !== null && context.itemInPreview.selectedItem.vivier.id === item.vivier.id && context.itemInPreview.isSelectedItemLoading

     // Shows item in preview
     function handleClickItemForPreview(e: React.MouseEvent<any>) {
          const clickedElement = e.target as HTMLElement
          // .not-concerned-by-preview elements are not concerned by the click
          if (!clickedElement.classList.contains("not-concerned-by-preview") && context.itemInPreview?.selectedItem.vivier.id !== item.vivier.id) {
               context.setAreFiltersVisible(false)

               context.setItemInPreview(
                    getSelectedItemPlusPreviousAndNextItem(item, index, context.listingQuery.data!.data, context.listingQuery.data!.page, context.listingQuery.data!.totalPages)
               )
          }
     }

     return <ListItem item={item} handleClickItemForPreview={handleClickItemForPreview} isItemSelected={isItemSelected} isItemLoading={isItemLoading} />
}

interface IListItemPropsModel {
     item: IGetViviersResponseItemModel
     handleClickItemForPreview: (e: React.MouseEvent<any>) => void
     isItemSelected: boolean
     isItemLoading: boolean
}

export default ViviersListingListItem
